module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/299.7f87fbdb.png";